import React from 'react';

const LinkedIn = props => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M10 18H6V6H10V8C10.8526 6.91525 12.1456 6.26857 13.525 6.237C16.0056 6.25077 18.0072 8.26938 18 10.75V18H14V11.25C13.84 10.1326 12.8818 9.30358 11.753 9.306C11.2593 9.32161 10.7932 9.53778 10.4624 9.90462C10.1316 10.2715 9.96464 10.7573 10 11.25V18ZM4 18H0V6H4V18ZM2 4C0.89543 4 0 3.10457 0 2C0 0.89543 0.89543 0 2 0C3.10457 0 4 0.89543 4 2C4 2.53043 3.78929 3.03914 3.41421 3.41421C3.03914 3.78929 2.53043 4 2 4Z" fill="currentColor" />
    </svg>
)

export default LinkedIn;